<p-dialog [(visible)]="display" (onHide)="onDialogHide()" appendTo="body"
  [resizable]="false" [closable]="true">

  <p-header>
    <span>{{title}}</span>
  </p-header>

  <div>
    <p style="width: 300px;">
      {{message}}
    </p>

    <hr />

    <div>
      <label for="username">User Name</label><br />
      <input name="username" type="text" pInputText [(ngModel)]="username" />
    </div>

    <div>
      <label for="password">Password</label><br />
      <input name="password" type="password" pInputText [(ngModel)]="password" />
    </div>

    <div>
      <label for="domain">Domain Name</label><br />
      <select name="domain" style="padding: 3.75px;" [(ngModel)]="domain">
        @for (d of domains; track d) {
          <option value="{{d}}"
            [attr.selected]="(d == domain) ? '' : null">
            {{d}}
          </option>
        }
      </select>
    </div>
  </div>

  <p-footer>
    <button type="button" pButton icon="fa fa-check" (click)="ok()" label="OK" [disabled]="!enableOk" autofocus></button>
    <button type="button" pButton icon="fa fa-close" (click)="cancel()" label="Cancel"></button>
  </p-footer>

</p-dialog>
